module.exports = __webpack_public_path__ + "2b28292febf0426afa31ac4a2044e9ec.png";